export default __webpack_public_path__ + "static/media/next-artisan.b20c2500.jpg";